import keyMirror from 'keymirror';

const ACTION_TYPES = keyMirror({
  RELOAD_PROVIDER_DATA: null,
  APP_INIT_SAGA: null,
  APP_INIT_RESET: null,
  INIT_PROVIDER_DATA_SAGA: null,
  USER_SIGNIN_SAGA: null,
  USER_SIGNOUT_SAGA: null,
  SIMPLE_SETUP_SAGA: null,
  QUEUE_DETAIL_SAGA: null,
  DELETE_ITEM_SAGA: null,
  SAVE_CONTROL_BOX_SAGA: null,
  CONTROL_BOX_COMMAND_SAGA: null,
  KIOSK_COMMAND_SAGA: null,
  SAVE_QUEUE_SAGA: null,
  SAVE_LOCATION_SAGA: null,
  SAVE_SERVICE_SAGA: null,
  SAVE_KIOSK_SAGA: null,
  UPDATE_KIOSK_SAGA: null,
  SAVE_BOOTH_SAGA: null,
  SAVE_DISPLAY_SAGA: null,
  HTTP_ERROR_SAGA: null,
  REVERSE_TUNNEL_SAGA: null,

  FETCH_USER_PROFILE_DONE: null,
  FETCH_SERVICE_PROVIDER_DONE: null,
  FETCH_SERVICE_PROVIDERS_DONE: null,
  FETCH_SERVICE_PROVIDER_USERS_DONE: null,
  FETCH_SERVICES_DONE: null,
  FETCH_KIOSKS_DONE: null,
  FETCH_BOOTHS_DONE: null,
  FETCH_DISPLAYS_DONE: null,
  FETCH_LOCATIONS_DONE: null,
  FETCH_CONTROL_BOXES_DONE: null,
  FETCH_QUEUES_DONE: null,
  FETCH_QUEUE_DETAIL_DONE: null,
  FETCH_CBX_QUEUE_STATUS_DONE: null,
  FETCH_IOT_DEVICE_STATUS_DONE: null,
  ITEM_DELETE_DONE: null,

  SIMPLE_SETUP_COMPLETED: null,
  APP_INIT_COMPLETED: null,
  WS_MESSAGE_ENTRY_ADDED: null,
  MESSAGE_TRACKER_SAGA: null,
  LOGGING_SET_CURRENT_LOG_ITEM: null,
  SEARCH_LOG_SAGA: null,
  FETCH_SEARCH_LOG_DONE: null,
  FETCH_CLOUD_LOG_LEVEL_DONE: null,
  SET_CLOUD_LOG_LEVEL_SAGA: null,
  FETCH_DEVICE_STATUS_DONE: null,
  PROVIDER_DEVICE_STATUS_SAGA: null,
  FETCH_DEVICE_STATUSES_DONE: null
});

export default { ...ACTION_TYPES };
